import { render } from "./OltList.vue?vue&type=template&id=33359925"
import script from "./OltList.vue?vue&type=script&lang=js"
export * from "./OltList.vue?vue&type=script&lang=js"

import "./OltList.vue?vue&type=style&index=0&id=33359925&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__